import React from 'react';
import { string, node, bool } from 'prop-types';

import { SvgIcon } from '../../../svg-icon';
import { StyledPopover, PopoverContent } from './styled-components';


const content = (
  <PopoverContent>
    <p><span>Max size:</span> 50Mb</p>
    <p>
      <span>Acceptable formats: </span>
      *.doc, *.docx, *.xls, *.xlsx, *.ppt, *.pptx, *.pdf, *.jpg, *.jpeg, *.png, *.mp3, *.zip
    </p>
  </PopoverContent>
);

export const Information = ({ title, children, inModal }) => (
  <StyledPopover
    trigger="hover"
    placement={inModal ? 'top' : 'topRight'}
    content={children || content}
    overlayStyle={inModal ? { width: '500px', paddingRight: '5px' } : {}}
    title={title}
  >
    <SvgIcon type="info" fillOpacity={0.7} style={{ marginRight: '3px' }} />
    <span>Info</span>
  </StyledPopover>
);


Information.propTypes = {
  title: string,
  children: node,
  inModal: bool,
};

Information.defaultProps = {
  title: 'Acceptable files',
  children: content,
  inModal: false,
};

export default Information;



// WEBPACK FOOTER //
// ./src/components/attachments/header/information/index.js